import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { QQShare, WxLaunchApp } from 'ThreeTerminal_mobile';
import { h5PageCount } from 'ThreeTerminal_utils';
import Grounds from 'ThreeTerminal_base/grounds';
import errorBoundary from '@ifeng/errorBoundary';
import { Picker } from 'antd-mobile';
import SwiperCore, { Autoplay } from 'swiper';
import { getCityMap, getPolicyNew } from '../../services/api';
import { callApp, getSchemeLink } from '@ifeng/callapp';

import 'antd-mobile/dist/antd-mobile.min.css';
import 'swiper/swiper-bundle.min.css';

SwiperCore.use([Autoplay]);

const Go = ({ startZn, handleClick }) => (
    <div className={styles.area} onClick={handleClick}>
        {startZn && <span>{startZn}</span>}
        {!startZn && <span className={styles.placeHolder}>选择出发地</span>}
        <span />
    </div>
);

const Dest = ({ endZn, handleClick }) => (
    <div className={styles.area} onClick={handleClick}>
        {endZn && <span>{endZn}</span>}
        {!endZn && <span className={styles.placeHolder}>选择目的地</span>}
        <span />
    </div>
);

Go.propTypes = {
    startZn: PropTypes.string,
    handleClick: PropTypes.func,
};

Dest.propTypes = {
    endZn: PropTypes.string,
    handleClick: PropTypes.func,
};

const Layout = ({ content: { modules, base62Id, shareTitle, shareThumbnail, introduction, devicetype } }) => {
    const [cityMap, setCityMap] = useState([]);
    const [startInfo, setStartInfo] = useState({ start: '', startZn: '' });
    const [endInfo, setEndInfo] = useState({ end: '', endZn: '' });
    const [startBoxShow, handleStartBoxShow] = useState(false);
    const [endBoxShow, handleEndBoxShow] = useState(false);
    const [toPolicy, setToPolicy] = useState({});
    const [fromPolicy, setFromPolicy] = useState({});
    const [showTelList, setShowTelList] = useState(false);
    const [telTabIndex, setTelTabIndex] = useState(0);
    const [dangerOneState, setDangerOneState] = useState(0);
    const [dangerTwoState, setDangerTwoState] = useState(0);
    const [policyOneState, setPolicyOneState] = useState(0);
    const [policyTwoState, setPolicyTwoState] = useState(0);

    const queryToPolicy = async code => {
        const policy = await getPolicyNew(code);

        setToPolicy({ ...policy });
    };

    const queryFromPolicy = async code => {
        const policy = await getPolicyNew(code);

        setFromPolicy({ ...policy });
    };

    useEffect(() => {
        try {
            const getCityMapData = async () => {
                const cityMap = await getCityMap();

                // 端内获取定位
                if (window.grounds) {
                    window.grounds.getLocation(jsonstr => {
                        let clientLocation = '';
                        let clentCode = '';

                        if (jsonstr && JSON.parse(jsonstr) && JSON.parse(jsonstr).lastCity) {
                            clientLocation = JSON.parse(jsonstr)
                                .lastCity.replace('市', '')
                                .replace('县', '')
                                .replace('自治区', '');
                        }

                        cityMap.forEach(provItem => {
                            if (provItem.children) {
                                provItem.children.forEach(cityItem => {
                                    if (clientLocation && cityItem.label === clientLocation && cityItem.value) {
                                        clentCode = cityItem.value;
                                    }
                                });
                            }
                        });

                        if (!clientLocation || !clentCode) {
                            clentCode = '110000';
                            clientLocation = '北京';
                        }

                        setStartInfo({
                            start: clentCode,
                            startZn: clientLocation,
                        });
                    });
                } else {
                    setStartInfo({ start: '110000', startZn: '北京' });
                }

                setCityMap([...cityMap]);
            };

            getCityMapData();
        } catch (e) {
            console.error(e);
        }

        if (devicetype === 'share') {
            // 分享页统计
            h5PageCount([
                {
                    behavior: 'page',
                    type: 'topic',
                    other: {
                        id: `special_ucms_${base62Id}`,
                        url: encodeURIComponent(location.href),
                        ref: encodeURIComponent(document.referrer),
                    },
                },
            ]);
        } else if (devicetype === 'client') {
            Grounds.pageStat({
                id: `special_ucms_${base62Id}`,
                type: 'other',
                url: encodeURIComponent(location.href),
                ref: encodeURIComponent(document.referrer),
            });
        }
    }, []);

    useEffect(() => {
        handleOpenSearch();
    }, [startInfo, endInfo]);

    const handleSetStartInfo = val => {
        // console.log(val, cityMap);

        const startObj = [...cityMap]
            .filter(item => item.value === val[0])[0]
            .children.filter(child => child.value === val[1])[0];

        setStartInfo({
            start: startObj.value,
            startZn: startObj.label,
        });
        handleStartBoxShow(false);
    };

    const handleSetEndInfo = val => {
        console.log(val, cityMap);

        const endObj = [...cityMap]
            .filter(item => item.value === val[0])[0]
            .children.filter(child => child.value === val[1])[0];

        setEndInfo({
            end: endObj.value,
            endZn: endObj.label,
        });
        handleEndBoxShow(false);
    };

    const handleStartAndEndChange = () => {
        const { start, startZn } = startInfo;
        const { end, endZn } = endInfo;

        setStartInfo({
            start: end,
            startZn: endZn,
        });
        setEndInfo({
            end: start,
            endZn: startZn,
        });
    };

    const handleOpenSearch = () => {
        const { start } = startInfo;
        const { end } = endInfo;

        queryToPolicy(end);
        queryFromPolicy(start);
    };

    const qqShareCofig = {
        title: shareTitle,
        img: shareThumbnail || 'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg',
        desc: introduction || '',
        cb: () => {
            console.log('分享成功');
        },
    };

    const handleCallAppClick = (isSendCount = true, isJumpQQlink = false, isCallAppWx = true) => {
        h5PageCount([
            {
                behavior: 'action',
                type: 'topic',
                other: {
                    id: `special_ucms_${base62Id}`,
                    url: encodeURIComponent(location.href),
                    ref: encodeURIComponent(document.referrer),
                },
            },
        ]);

        if (isCallAppWx) {
            callApp({
                kind: 'inter_fxyzt02',
                docType: 'web',
                noKindFrom: 1,
                pid: 'https://ishare.ifeng.com/c/s/8Ce6NJfpOcK?webkit=1',
                // pid: 'http://192.168.0.100:8087/isolationPolicyNew.html?webkit=1&needpage=1',
                download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1450306105889',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8791',
                isJumpQQlink,
            });
        }
    };

    const handleClientCallApp = () => {
        if (window && window.grounds) {
            window.grounds.openShare(
                'https://ishare.ifeng.com/c/s/8Cq98cOfqkK?webkit=1',
                '出行防疫政策查询 春节返乡、出差、旅游快来看看',
                '春节返乡需要隔离吗？各地防疫措施一键查询',
                'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg',
                'newyear_share',
            );
        }
    };

    const schemeLink = getSchemeLink({
        kind: 'inter_fxyzt02',
        docType: 'web',
        noKindFrom: 1,
        pid: 'https://ishare.ifeng.com/c/s/8Ce6NJfpOcK?webkit=1',
    });

    const handelShowTelList = () => {
        if (fromPolicy.cityname) {
            setShowTelList(true);
        } else {
            alert('请点击查询按钮后进行点击');
        }
    };

    return (
        <div className={styles.layout}>
            <QQShare content={qqShareCofig} />
            <div className={styles.banner}>
                <img
                    className={styles.bannerPic}
                    src="https://x0.ifengimg.com/ucms/2022_03/6D070380CEEAB9C328A6A297D22215E9352C39F9_size162_w1125_h486.png"
                />
            </div>
            <div className={styles.option_box}>
                <div className={styles.option}>
                    <div className={styles.select_box}>
                        <Picker
                            cols={2}
                            visible={startBoxShow}
                            data={[...cityMap]}
                            onOk={val => handleSetStartInfo(val)}
                            onDismiss={() => handleStartBoxShow(false)}>
                            <Go startZn={startInfo.startZn} handleClick={() => handleStartBoxShow(true)} />
                        </Picker>
                        <span onClick={handleStartAndEndChange} />
                        <Picker
                            cols={2}
                            visible={endBoxShow}
                            data={[...cityMap]}
                            onOk={val => handleSetEndInfo(val)}
                            onDismiss={() => handleEndBoxShow(false)}>
                            <Dest endZn={endInfo.endZn} handleClick={() => handleEndBoxShow(true)} />
                        </Picker>
                    </div>
                    {/* <div className={styles.openSearchBtn} onClick={() => handleOpenSearch()}>开始查询</div> */}
                </div>
            </div>
            <div className={styles.optionInfo}>
                内容综合当地卫健委和权威网站，可能更新不及时或有错漏，建议出行前通过下方电话查询，与防疫部门再次确认。
            </div>
            <div className={styles.content}>
                {(toPolicy.cityname || fromPolicy.cityname) && (
                    <>
                        <div className={styles.title}>
                            <span />
                            <span>出行政策</span>
                        </div>
                        {fromPolicy.cityname && (
                            <div className={styles.start_policy}>
                                <div className={styles.travel_title}>
                                    <span className={styles.travelGoIcon} />
                                    <span className={styles.travelName}>{fromPolicy.cityname || ''}</span>
                                    <div className={styles.hightSection}>
                                        <div className={styles.hightSectionText}>高风险地区</div>
                                        <div className={styles.hightSectionNum}>
                                            {fromPolicy.high_risk_area_count || 0}个
                                        </div>
                                    </div>
                                    <div className={styles.middleSection}>
                                        <div className={styles.hightSectionText}>中风险地区</div>
                                        <div className={styles.hightSectionNum}>
                                            {fromPolicy.medium_risk_area_count || 0}个
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.travelGoText}>离开政策</div>
                                <div className={styles.policy_content}>
                                    {fromPolicy.leave_policy ? (
                                        <p
                                            style={{ display: policyOneState === 0 ? '-webkit-box' : 'block' }}
                                            dangerouslySetInnerHTML={{ __html: fromPolicy.leave_policy }}>
                                            {/* {fromPolicy.leave_policy} */}
                                        </p>
                                    ) : (
                                        '暂无相关政策信息'
                                    )}
                                </div>
                                {fromPolicy.leave_policy && fromPolicy.leave_policy.length > 131 && (
                                    <>
                                        {policyOneState === 0 && (
                                            <div
                                                onClick={() => {
                                                    setPolicyOneState(1);
                                                }}
                                                className={styles.policyUp}>
                                                查看更多
                                            </div>
                                        )}
                                        {policyOneState === 1 && (
                                            <div
                                                onClick={() => {
                                                    setPolicyOneState(0);
                                                }}
                                                className={styles.policyDown}>
                                                收起
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        )}
                        {toPolicy.cityname && (
                            <div className={styles.end_policy}>
                                <div className={styles.travel_title}>
                                    <span className={styles.travelEndIcon} />
                                    <span className={styles.travelName}>{toPolicy.cityname || ''}</span>
                                    <div className={styles.hightSection}>
                                        <div className={styles.hightSectionText}>高风险地区</div>
                                        <div className={styles.hightSectionNum}>
                                            {toPolicy.high_risk_area_count || 0}个
                                        </div>
                                    </div>
                                    <div className={styles.middleSection}>
                                        <div className={styles.hightSectionText}>中风险地区</div>
                                        <div className={styles.hightSectionNum}>
                                            {toPolicy.medium_risk_area_count || 0}个
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.travelGoText}>到达政策</div>
                                <div className={styles.policy_content}>
                                    {toPolicy.back_policy ? (
                                        <p
                                            style={{ display: policyTwoState === 0 ? '-webkit-box' : 'block' }}
                                            dangerouslySetInnerHTML={{ __html: toPolicy.back_policy }}></p>
                                    ) : (
                                        '暂无相关政策信息'
                                    )}
                                </div>
                                {toPolicy.back_policy && toPolicy.back_policy.length > 131 && (
                                    <>
                                        {policyTwoState === 0 && (
                                            <div
                                                onClick={() => {
                                                    setPolicyTwoState(1);
                                                }}
                                                className={styles.policyUp}>
                                                查看更多
                                            </div>
                                        )}
                                        {policyTwoState === 1 && (
                                            <div
                                                onClick={() => {
                                                    setPolicyTwoState(0);
                                                }}
                                                className={styles.policyDown}>
                                                收起
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        )}
                    </>
                )}
                {((fromPolicy.poi_list && fromPolicy.poi_list.length > 0) ||
                    (toPolicy.poi_list && toPolicy.poi_list.length > 0)) && (
                    <>
                        <div className={styles.title}>
                            <span />
                            <span>风险地区提示</span>
                        </div>
                        {fromPolicy.poi_list && fromPolicy.poi_list.length > 0 && (
                            <div className={styles.start_level}>
                                <div className={styles.start_area}>
                                    <span>
                                        <span />
                                        <span>{fromPolicy.cityname}</span>
                                    </span>
                                    <span>{fromPolicy.updateTime && `${fromPolicy.updateTime}更新`}</span>
                                </div>
                                {fromPolicy.poi_list.slice(0, dangerOneState === 0 ? 7 : 1000).map((item, index) => {
                                    return (
                                        <div key={index} className={styles.levelItem}>
                                            <div className={styles.levelInfo}>{item.area}</div>
                                            {item.type === '2' && <div className={styles.highlevelText}>高风险</div>}
                                            {item.type === '1' && <div className={styles.mediumlevelText}>中风险</div>}
                                        </div>
                                    );
                                })}
                                {fromPolicy.poi_list && fromPolicy.poi_list.length > 7 && (
                                    <>
                                        {dangerOneState === 0 && (
                                            <div
                                                onClick={() => {
                                                    setDangerOneState(1);
                                                }}
                                                className={styles.levelUpIcon}>
                                                展开
                                            </div>
                                        )}
                                        {dangerOneState === 1 && (
                                            <div
                                                onClick={() => {
                                                    setDangerOneState(0);
                                                }}
                                                className={styles.levelDownIcon}>
                                                收起
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        )}
                        {toPolicy.poi_list && toPolicy.poi_list.length > 0 && (
                            <div className={styles.end_level}>
                                <div className={styles.end_area}>
                                    <span>
                                        <span />
                                        <span>{toPolicy.cityname}</span>
                                    </span>
                                    <span>{toPolicy.updateTime && `${toPolicy.updateTime}更新`}</span>
                                </div>
                                {toPolicy.poi_list.slice(0, dangerTwoState === 0 ? 7 : 1000).map((item, index) => {
                                    return (
                                        <div key={index} className={styles.levelItem}>
                                            <div className={styles.levelInfo}>{item.area}</div>
                                            {item.type === '2' && <div className={styles.highlevelText}>高风险</div>}
                                            {item.type === '1' && <div className={styles.mediumlevelText}>中风险</div>}
                                        </div>
                                    );
                                })}
                                {toPolicy.poi_list && toPolicy.poi_list.length > 7 && (
                                    <>
                                        {dangerTwoState === 0 && (
                                            <div
                                                onClick={() => {
                                                    setDangerTwoState(1);
                                                }}
                                                className={styles.levelUpIcon}>
                                                展开
                                            </div>
                                        )}
                                        {dangerTwoState === 1 && (
                                            <div
                                                onClick={() => {
                                                    setDangerTwoState(0);
                                                }}
                                                className={styles.levelDownIcon}>
                                                收起
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        )}
                    </>
                )}
                <div className={styles.title}>
                    <span />
                    <span>更多疫情信息</span>
                </div>
                <div className={styles.moreInfoItem1}>
                    <a
                        onClick={() => {
                            handelShowTelList();
                        }}
                        className={styles.moreInfoItemLink}>
                        <img src="https://x0.ifengimg.com/ucms/2022_04/000154FEBE41A8FAE76853E6DE58F2D27703E27C_size20_w498_h210.png" />
                    </a>
                    <a href="https://ishare.ifeng.com/c/s/7tPlDSzDgVk?webkit=1" className={styles.moreInfoItemLink}>
                        <img src="https://x0.ifengimg.com/ucms/2022_04/9CB78BE6AB1F0EC8E6BF8E08A77C6266681F273C_size20_w498_h210.png" />
                    </a>
                </div>
                <div className={styles.moreInfoItem2}>
                    <a
                        href="https://ishare.ifeng.com/c/s/7uLj4F83Cqm?needpage=1&webkit=1"
                        className={styles.moreInfoItemLink}>
                        <img src="https://x0.ifengimg.com/ucms/2022_04/5D6F145B62FC1FDC2B1F3C0C0469E40F88096195_size17_w498_h210.png" />
                    </a>
                    <a href="https://ishare.ifeng.com/c/s/85mhVvWS5i4?webkit=1" className={styles.moreInfoItemLink}>
                        <img src="https://x0.ifengimg.com/ucms/2022_04/5D03D609F41E9DB1263A504009CB8FEA66790C08_size24_w498_h210.png" />
                    </a>
                </div>
            </div>
            {/* 端内 */}
            {window.grounds ? (
                <div className={styles.fixBottom} onClick={handleClientCallApp}>
                    <img
                        className={styles.fixBottomPic}
                        src="https://x0.ifengimg.com/ucms/2022_04/72E8B08AAE4DB407EAC935106032351D470E43EA_size4_w936_h132.png"
                    />
                </div>
            ) : (
                <div onClick={handleCallAppClick} className={styles.fixBottom}>
                    <img
                        className={styles.fixBottomPic}
                        src="https://x0.ifengimg.com/ucms/2022_04/FE6030224A569393233A692CB5ECEB5907D5EE6D_size8_w936_h132.png"
                    />
                    <WxLaunchApp
                        launchType="app"
                        launchAppClick={handleCallAppClick.bind(this, true, false, false)}
                        schemeLink={schemeLink}
                        launchAppFail={handleCallAppClick.bind(this, false, true, true)}
                    />
                </div>
            )}
            {showTelList && (
                <div className={styles.telBg}>
                    <div className={styles.telBox}>
                        <div className={styles.telBoxContent}>
                            <div className={styles.telBoxHead}>
                                <div
                                    className={styles.telBoxClose}
                                    onClick={() => {
                                        setShowTelList(false);
                                    }}
                                />
                                <div
                                    className={`${styles.telBoxTab} ${telTabIndex === 0 ? styles.active : ''}`}
                                    onClick={() => {
                                        setTelTabIndex(0);
                                    }}>
                                    {fromPolicy.cityname}
                                </div>
                                <div
                                    className={`${styles.telBoxTab} ${telTabIndex === 1 ? styles.active : ''}`}
                                    onClick={() => {
                                        setTelTabIndex(1);
                                    }}>
                                    {toPolicy.cityname}
                                </div>
                            </div>
                            {telTabIndex === 0 && (
                                <div className={styles.telBoxItem}>
                                    <div className={styles.telBoxItemScroll}>
                                        <div className={styles.telBoxJob}>防疫部门</div>
                                        {fromPolicy.phone_list.map((item, index) => {
                                            return (
                                                <div key={index} className={styles.telBoxList}>
                                                    <div className={styles.telBoxListLeft}>
                                                        <div className={styles.telBoxListLeftText}>
                                                            {item.institution_name}
                                                        </div>
                                                        <div className={styles.telBoxListLeftNum}>{item.phone_num}</div>
                                                    </div>
                                                    <div className={styles.telBoxListRight}>
                                                        <a
                                                            className={styles.telBoxListRightIcon}
                                                            href={`tel:${item.phone_num}`}
                                                        />
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                            {telTabIndex === 1 && (
                                <div className={styles.telBoxItem}>
                                    <div className={styles.telBoxItemScroll}>
                                        <div className={styles.telBoxJob}>防疫部门</div>
                                        {toPolicy.phone_list.map((item, index) => {
                                            return (
                                                <div key={index} className={styles.telBoxList}>
                                                    <div className={styles.telBoxListLeft}>
                                                        <div className={styles.telBoxListLeftText}>
                                                            {item.institution_name}
                                                        </div>
                                                        <div className={styles.telBoxListLeftNum}>{item.phone_num}</div>
                                                    </div>
                                                    <div className={styles.telBoxListRight}>
                                                        <a
                                                            className={styles.telBoxListRightIcon}
                                                            href={`tel:${item.phone_num}`}
                                                        />
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
